import { translate, plainText } from '../../ContentTranslation';
import React, { Component } from 'react';
import './Companion.css';
import Entity from './Entity';
import { Tooltip } from 'reactstrap';

export default class Companion extends Component {

  state = {
    tooltip: null
  }

  toggleTooltip (tooltip, touch) {

    if (tooltip === this.state.tooltip && this.state.tooltipDate && new Date() - this.state.tooltipDate < 500)
      return;

    if (touch) {
      
      if (this.tooltipTimeout)
        clearTimeout(this.tooltipTimeout);

      this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip, tooltipDate: new Date()});
      this.tooltipTouch = touch;
      this.tooltipTimeout = setTimeout(() => this.toggleTooltip(null), 3000);
      return;
    }

    this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip});
  }

  render () {

    /*let scale = undefined;
    if (this.props.src.champion)
      scale = this.props.src.champion.scale;
    else if (this.props.src.model && this.props.src.model.scale) {
      let scales = this.props.src.model.scale;
      for (let s of scales) {
        if (s.from > this.props.src.level)
          break;
        scale = s.value;
      }
    }*/

    let scale = 0.67;

    return (
      <div className="game-companion">
        <Entity onSelect={this.props.onSelect} src={this.props.src} scale={scale} intent={this.props.src.run.room.fight && this.props.src.run.room.fight.companion ? this.props.src.run.room.fight.companion.intent : null}/>
        <Tooltip className="tooltip companion-tooltip" placement="top" isOpen={this.state.tooltip === "game-companion"} target={"game-entity-companion"} toggle={() => this.toggleTooltip("game-companion")}>
          <b><img src={"/images/companion.png"}/>{ this.props.src.model.name }</b><br/>
          <span className="shop-companion-skill"><b>{translate("Skill:")}</b>&nbsp;{plainText(this.props.src.model.skill.effect)}</span><br/>
          <span className="shop-companion-auto"><b>{translate("Action:")}</b>&nbsp;{plainText(this.props.src.model.action.effect)}<br/></span>
        </Tooltip>
        {/*<div className="game-companion-energy-wrapper">
          <div className="game-companion-energy">
          {
            Array.from({ length: this.props.src.maxEnergy }, (_, i) =>
              <div key={i} className="game-companion-energy-segment">
                { i < this.props.src.energy && <div className="game-companion-energy-fill"/>}
              </div>)
          }
          </div>
          <div className="game-entity-life-text">{ this.props.src.energy + "/" + this.props.src.maxEnergy }</div>
        </div>*/}
      </div>
    );
  }
}

